import { times } from 'lodash';

export default function createMdItemsTemplate() {
    return times(3, index => ({
        // Rubric on example (index 0) only
        ...(index === 0 && {
            rubric_id: '',
        }),

        is_example: index === 0,
        audio_id: null,
        answer_type: 'image',

        answers: times(3, () => ({
            is_correct_answer: false,
            image_id: '',
            text: ''
        })),
    }));
}